import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IData } from '../types/shared';

export interface IApuracao {
  id?: number;
  dt_apuracao: string;
  dt_competencia: string;
  usuario: string;
}

interface IApuracaoFilter {
  page?: number | string;
  size?: number | string;
  empresa_id: string | number;
  date_start?: string;
  date_end?: string;
}

export const useApuracoes = () => {
  const getApuracoes = async (context: QueryFunctionContext): Promise<IData<IApuracao[]>> => {
    const filters = context.queryKey[1] as IApuracaoFilter;

    const res = await api.get<IData<IApuracao[]>>('/api/v1/empresas/apuracoes', {
      params: filters,
    });

    return res.data;
  };

  return {
    getApuracoes,
  };
};
